// URL search params for focus mode, and the cards a bundle session walks
// (docs/design/bundles.md): `/focus?bundle=<id>` holds only that bundle's members, in bundle order.
import type { BundleView } from "@shared/api";

export interface FocusSearch {
  /** Walk only this bundle's members (Review drafts). */
  bundle?: string | undefined;
}

export function parseFocusSearch(raw: Record<string, unknown>): FocusSearch {
  const bundle = typeof raw.bundle === "string" ? raw.bundle.trim() : "";
  return bundle ? { bundle } : {};
}

/**
 * The card ids a bundle session holds: the proposed bundle's members still in this round's review
 * list, in bundle order. Null when there is no such bundle (missing, done or stale, or none of its
 * members is left): focus then walks the round as usual.
 */
export function bundleSessionIds(
  bundleId: string | undefined,
  bundles: readonly BundleView[] | undefined,
  reviewIds: readonly string[],
): string[] | null {
  if (!bundleId) return null;
  const bundle = bundles?.find((b) => b.id === bundleId);
  if (!bundle || bundle.status !== "proposed") return null;
  const inRound = new Set(reviewIds);
  const ids = [...new Set(bundle.cardIds)].filter((id) => inRound.has(id));
  return ids.length ? ids : null;
}
